import { effect, Injectable, signal } from '@angular/core';
import { SportType } from '../../../../shared/constants/sport-type';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { PlatformService } from './platform.service';

@Injectable({
  providedIn: 'root',
})
export class SportFilterService {
  show = signal<boolean | undefined>(undefined);
  filter = signal<SportType | ''>(environment.defaultSportType as SportType);

  constructor(private nav: Router, private platform: PlatformService) {
    this.setDefaultUserSportType();
    effect(() => {
      if(this.platform.isBrowser()) {
        localStorage.setItem('sportType', this.filter());
      }
    });
  }

  // Get the user prefered sport type
  setDefaultUserSportType() {
    let userSportType = '';
    if(this.platform.isBrowser()) {
      userSportType = localStorage.getItem('sportType') ?? '';
    }
    if (userSportType || userSportType === '') {
      this.filter.set(userSportType as SportType);
      return;
    }
    this.filter.set(environment.defaultSportType as SportType);
  }

  // Show the sport filter
  showSportFilter() {
    this.show.set(true);
  }

  // Hide the sport filter
  hideSportFilter() {
    this.show.set(false);
  }
}
